import Iridescence from './Iridescence';
import StarBorder from './StarBorder';

const ForGenAI = () => {
  return (
    <a
      href="https://forgen.ai/"
      target="_blank"
      rel="noopener noreferrer"
      className="md:fixed mt-4 md:right-10 bottom-2 z-50"
    >
      <StarBorder
        as="div"
        className="transition-all duration-300 hover:scale-105"
        color="white"
        speed="3s"
      >
        <div className="relative w-32 h-12 rounded-lg overflow-hidden shadow-lg hover:shadow-2xl">
          <div className="absolute inset-0 opacity-90">
            <Iridescence
              color={[1.2, 0.7, 1.5]}
              speed={0.8}
              amplitude={0.2}
              mouseReact={true}
            />
          </div>
          <div className="absolute inset-0 bg-white/40 backdrop-blur-[2px]"></div>
          <div className="relative z-10 flex items-center justify-center h-full px-3">
            <img src="/ForGenAI_Logo.png" className="w-full h-auto" alt="ForGen AI" />
          </div>
        </div>
      </StarBorder>
    </a>
  );
};

export default ForGenAI;
